import React from 'react'
import { Link, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '../components/layout'

import { BannerBlog } from '../components/BannerBlog'
const spanStyle = {
  fontWeight: 200,
  margin:     '0 15px 0 0',
  fontSize:   '0.8em',
}
const BlogLinks = ({ data }) => {
  const { edges: posts } = data.allMarkdownRemark

  return (
    <Layout>
      <Helmet>
        <title>Blog - Guntars Simanskis</title>
        <meta name="description" content="About me"/>
      </Helmet>

      <BannerBlog
        title={`Blog`}
        date={`Guntars Simanskis`}
        description={`This is my blog for different Coding challenges.`}
      />

      <div id="main">
        {posts
          .filter(post => post.node.frontmatter.title.length > 0)
          .map(({ node: post }) => {

            return (
              <section id={post.id} key={post.id} className="spotlights">
                <section>
                  <div className="content">
                    <div className="inner">
                      <header className="major">
                        <h3>
                          <Link to={post.frontmatter.path}>
                            {post.frontmatter.title}
                          </Link>
                        </h3>
                        <p>
                          <span className="small" style={spanStyle}>Author: Guntars Simanskis</span><br/>
                          <span className="small" style={spanStyle}>Published: {post.frontmatter.date}</span>
                        </p>
                      </header>
                      <dd>
                        <Link to={post.frontmatter.path}>
                          <p>{post.excerpt}</p>
                        </Link>
                      </dd>
                    </div>
                  </div>
                </section>
              </section>
            )
          })}
      </div>
    </Layout>
  )
}
export default BlogLinks

export const pageQuery = graphql`
    query IndexQuery {
        allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
            edges {
                node {
                    excerpt(pruneLength: 250)
                    id
                    frontmatter {
                        title
                        date(formatString: "MMMM DD, YYYY")
                        path
                        description
                    }
                }
            }
        }
    }
`
